<template >
  <div v-if="inputObj.params && inputObj.params.is_panel">
    <ul
        v-if="Object.keys(inputObj.langs).length > 1"
        class="nav nav-tabs mb-2"
    >
      <li
          v-for="(langItem, langIndex)  in inputObj.langs"
          class="nav-item"
      >
        <a
            :class="'nav-link' + ((activeTab == langIndex)? ' active':'')"
            @click.prevent="changeTab(langIndex)"
            href="#"
        >
          <country-flag
              :country='langItem.flag'
              size="small"
          />
          {{langItem.title}}

        </a>
      </li>
    </ul>

    <template
        v-for="(langItem, langIndex)  in inputObj.langs"
    >
      <div
          v-show="activeTab == langIndex"
      >
        <html-editor2
            v-if="inputObj.type=='wysiwig'"
            v-model="inputModel[langIndex]"
            editor-type="segment_odstavec"
        />
        <textarea
            v-else
            v-model="inputModel[langIndex]"
            :id="inputObj.name + '_lang_' + langIndex"
            type="text"
            class="form-control"
        >
        </textarea>
      </div>
    </template>
<!--


    <display-debug>
      <template #debugView>
        {{inputObj}}
      </template>
    </display-debug>
-->
  </div>

  <div
      v-else
      v-for="(langItem, langIndex)  in inputObj.langs"
  >
    <!--
    <div v-html="langItem.svg" style="max-height: 30px;"></div>
    -->

    <label :for="inputObj.name + '_lang_' + langIndex">
      <country-flag
          :country='langItem.flag'
          size="small"
      />
      {{langItem.title}}
    </label>
    <html-editor2
        v-if="inputObj.type=='wysiwig'"
        v-model="inputModel[langIndex]"
        editor-type="segment_odstavec"
    />

    <textarea
        v-else
        v-model="inputModel[langIndex]"
        :id="inputObj.name + '_lang_' + langIndex"
        :required="this.inputObj.required"
        class="form-control"
        @focus="is_locked=true;"
        :maxlength="(inputObj.params && inputObj.params.maxlength)? inputObj.params.maxlength : false"
    >
    </textarea>


  </div>
</template>

<script>
import axios from "axios";
import { QuillEditor } from '@vueup/vue-quill'
import { QuillPlaceholderModule } from 'quill-placeholder-module'
import {QuillHtmlEditButton} from "quill-html-edit-button";
import CountryFlag from "vue-country-flag-next"
import htmlEditor2 from "@/components/content/htmlEditor_v2.vue";
import DisplayDebug from "@/components/general/DisplayDebug.vue";
let timer;
let timerModel;
export default {
  name: "TextareaInputLang",
  components: {
    DisplayDebug,
    htmlEditor2,
    QuillEditor,
    QuillPlaceholderModule,
    //QuillMention,
    QuillHtmlEditButton,
    CountryFlag,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": Object, Array,
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    }

  },
  data() {
    return {
      inputModel: null,
      is_locked: false,
      timer: null,
      timer_delay: 700,
      activeTab: null,
    }
  },
  created() {
    if(this.inputObj.langs) {

      for (const i in this.inputObj.langs){
        //console.log('dev TextAreaSegment created set lang', i)
        if(this.activeTab === null) {

          this.activeTab = i;
        }
        //console.log('dev TextAreaSegment created obsah', i, this.inputObj.obsah)

      }
    }
  },
  mounted() {
    //console.log('dev textare anotace', this.formObj.general.inputs.segment.val)
    if(this.inputObj.val != '' && this.inputObj.val != null ) {
      this.is_locked = true;
    }
    this.inputModel = this.inputObj.val;
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },

    async createAnotationFromSegment(segment){
      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('obsah.create_anotation.path') // this.cfg.api.obsah.create_anotation.path;
      let formData = new FormData;
      formData.append(this.getApiConfig('obsah.create_anotation.input.segment'), JSON.stringify(segment))
      axios({
        url: apiPath,
        method: this.getApiConfig('obsah.create_anotation.method'),
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.status && res.data.response.anotace){
          if (this.inputObj.params.maxlength &&  res.data.response.anotace.length > this.inputObj.params.maxlength) {
            this.inputModel = res.data.response.anotace.substring(0, this.inputObj.params.maxlength) + "..."
          } else {
            this.inputModel = res.data.response.anotace;
          }
        }
      })
      .catch((err) => {
        //console.log("DEV createAnotationFromSegment ERR ", err);
      })
    }
  },
  watch: {
    activeLang: {
      handler() {
        this.activeTab = this.activeLang;
      },
      deep: true,
      immediate: true
    },
    "formObj.general.inputs.segment.val": {
      handler(newVal) {
        if(this.inputObj.type && this.inputObj.type == "anotation" && !this.is_locked) {
          if(timer) clearInterval(timer);
          timer = setTimeout(
              () => {
                this.createAnotationFromSegment(newVal)
             },
              this.timer_delay
          )
        }
      },
      deep: true,
      immediate: true
    },
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal) {
        if(timerModel) clearInterval(timerModel);
        timerModel = setTimeout(
            () => {
              this.$emit('update:modelValue', newVal )
            },
            this.timer_delay
        )
      },
      deep: true,
      immediate: true
    },
  },
};
</script>